import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage, getStartDate } from "../../services/helper/cl_Helper";
import moment from "moment";
import { handleLogout } from "../changePin/cl_ChangePinSlice";

const initialState = {
  accountHistoryData: [],
  cancelRes: "",
  totalRecords: 0,
  loader:false
};
// const token = getFromLocalStorage("gk");
export const accountHistorySlice = createSlice({
  name: "accountHistory",
  initialState,
  reducers: {
    setAccountHistoryData: (state, action) => {
      state.accountHistoryData = action.payload;
    },
    setCancelRes: (state, action) => {
      state.cancelRes = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    }
  },
});

export const { setAccountHistoryData, setCancelRes, setTotalRecords ,setLoader } =
  accountHistorySlice.actions;

export default accountHistorySlice.reducer;

export const fetchAccountHistory = (paymentType, durationType, pageNum,token) => (dispatch) => {
  dispatch(setLoader(true));
  const startDate = getStartDate(durationType)
  let url = endpoints.accountHistory;
  const endDate = new Date()
  const payload = {
    clientType: "mobile",
    accessToken: token,
    paymentType: paymentType ? paymentType : 'DEPOSIT',
    endDate: endDate,
    itemsPerPage: 10,
    pageNumber: pageNum,
    startDate: startDate
    
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      if(res?.data?.result?.status == 401){
        console.log(res?.data?.result?.message);
        dispatch(handleLogout(token))
      } else if (res?.data?.result?.data) {
        dispatch(setAccountHistoryData(res?.data?.result?.data));
        dispatch(setTotalRecords(res?.data?.result?.totalRecords))
      } else {
        setAccountHistoryData([])
      }
      dispatch(setLoader(false));
    } else {
      setAccountHistoryData([])
    }
  });
};

export const cancelTransactionRequest = (mobNum,token) => (dispatch) => {
  let url = endpoints.cancelWithdraw;
  const payload = {
    Id: "TNX-0000264H",
    clientType: "mobile",
    accessToken: token,
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setCancelRes(res.data));
      dispatch(fetchAccountHistory());
    }
  });
};
